/**
 * @enum
 */
export const applicationStageType = {
  focus: 'focus',
  funnel: 'funnel',
}
